import React from 'react';
import { SeverityBadge } from './MaintenanceFlagsPanel';
import type { AssignmentMaintenanceWarning } from '../../lib/maintenance-warnings';

/**
 * The maintenance-watch lines on an equipment picker row, under the cert line.
 *
 * Advice only — see lib/maintenance-warnings.ts. Renders NOTHING for an empty
 * list, which is also what an absent key (shadow/off) becomes: there is no
 * "checked, all clear" line, because shadow mode is not a clean bill of health.
 *
 * The badge is the FE-1 severity badge (saturated fill, dark ink). The message
 * is the API's sentence, verbatim, in body ink rather than a signal hue — a
 * `--fi-signal-*` hue is a fill, not an ink.
 */
export function AssignmentMaintenanceWarnings({ warnings }: { warnings: AssignmentMaintenanceWarning[] }) {
  if (warnings.length === 0) return null;
  return (
    <ul data-testid="assignment-maintenance-warnings" className="mt-1.5 space-y-1">
      {warnings.map((w, i) => (
        <li key={`${w.flagType}-${i}`} className="flex items-start gap-2 text-xs text-fieldiq-text">
          <SeverityBadge severity={w.severity} />
          <span className="min-w-0">{w.message}</span>
        </li>
      ))}
    </ul>
  );
}

/** The body of the post-save notice: each message, verbatim. */
export function MaintenanceNoticeBody({ warnings }: { warnings: AssignmentMaintenanceWarning[] }) {
  return (
    <ul className="mt-1 space-y-0.5">
      {warnings.map((w, i) => <li key={`${w.flagType}-${i}`}>{w.message}</li>)}
    </ul>
  );
}
